<script setup lang="ts">
import Quill from "quill";
import { useWordProcessorStore } from "../useWordProcessorStore";

const wordProcessorInstanceId = inject("instanceId") as string;
const wordProcessorStore = useWordProcessorStore(wordProcessorInstanceId);
const { selectionRange, quillDelta } = storeToRefs(wordProcessorStore);

const editorRef = inject("quillEditor") as any;

const activeAlignment = computed(() => {
  const quill = editorRef.value?.getQuill?.();
  if (!quill) return "";

  const selection = selectionRange.value;
  if (!selection) return "";

  const format = quill.getFormat(selection.index, selection.length);
  return format.align || "";
});

// Helper function to convert hex color to rgba with transparency
const hexToRgba = (hex: string, alpha: number) => {
  if (!hex) return "";
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

const onColorSelected = (color: string) => {
  // TODO: Implement color selection logic

  const quill = editorRef.value?.getQuill?.();
  if (!quill) return;

  const selection = quill.getSelection();

  if (!selection) return;

  if (selection.index == undefined || selection.length == undefined) return;

  quill.formatText(
    selection.index,
    selection.length,
    "color",
    color,
    Quill.sources.USER
  );
};

const onAlignmentSelected = (alignment: string) => {
  const quill = editorRef.value?.getQuill?.();
  if (!quill) return;

  quill.format(
    "align",
    alignment === "left" ? false : alignment,
    Quill.sources.USER
  );
};
</script>

<template>
  <!-- Text Color Picker -->
  <BasePopover align="start" trigger-class="!w-[30px] !h-[30px] !p-0 rounded">
    <div
      v-tooltip="'Alignment'"
      class="w-[30px] h-[30px] rounded hover:bg-light flex items-center justify-center relative"
    >
      <icon
        v-if="activeAlignment == 'left' || activeAlignment == ''"
        name="lucide:text-align-start"
        size="16"
      />
      <icon
        v-if="activeAlignment == 'center'"
        name="lucide:text-align-center"
        size="16"
      />
      <icon
        v-if="activeAlignment == 'right'"
        name="lucide:text-align-end"
        size="16"
      />
      <icon
        v-if="activeAlignment == 'justify'"
        name="lucide:text-align-justify"
        size="16"
      />
    </div>
    <template #content>
      <div class="p-1">
        <BaseIconButton
          @click="onAlignmentSelected('left')"
          v-tooltip.right="'Align Left'"
          
        >
          <icon name="lucide:text-align-start" size="16" />
        </BaseIconButton>
        <BaseIconButton
          @click="onAlignmentSelected('center')"
          v-tooltip.right="'Center'"
        >
          <icon name="lucide:text-align-center" size="16" />
        </BaseIconButton>
        <BaseIconButton
          @click="onAlignmentSelected('right')"
          v-tooltip.right="'Align Right'"
        >
          <icon name="lucide:text-align-end" size="16" />
        </BaseIconButton>
        <BaseIconButton
          @click="onAlignmentSelected('justify')"
          v-tooltip.right="'Justify'"
        >
          <icon name="lucide:text-align-justify" size="16" />
        </BaseIconButton>
      </div>
    </template>
  </BasePopover>
</template>

<style scoped></style>
